import React from 'react'

import {Tabs, Tab} from 'react-bootstrap'

import Switch from '../ui/Switch'

import DetailViewApp from '../ads/app/DetailViewApp'
import TeaserAppStreamBasic from '../ads/app/TeaserAppStreamBasic'
import AppChallengeCenter from '../ads/app/appchallengecenter/AppChallengeCenter'
import PhotoCredit from '../ads/app/PhotoCredit'
import AppQuiz from '../ads/app/AppQuiz/AppQuiz'

import PremiumOffer from '../ads/mailing/PremiumOffer'
import TopOffer from '../ads/mailing/TopOffer'
import BasicOffer from '../ads/mailing/BasicOffer'

import TeaserAwardBookingConfirmationScreen from '../ads/mam/TeaserAwardBookingConfirmationScreen'

import OfferBanner from '../ads/mam3/OfferBanner'
import OfferBannerSpend from '../ads/mam3/OfferBannerSpend'
import OfferPromo from '../ads/mam3/OfferPromo'
import PromoOfferPage from '../ads/mam3/PromoOfferPage'
import BasicOfferPage from '../ads/mam3/BasicOfferPage'
import OfferTeaser from '../ads/mam3/OfferTeaser'
import NewRevolvingStage from '../ads/mam3/NewRevolvingStage'
import OfferHub from '../ads/mam3/OfferHub'
import TeaserAction from "../ads/creditcard/TeaserAction";
import TeaserAdditionalOffer from "../ads/creditcard/TeaserAdditionalOffer";
import TeaserDidYouKnow from "../ads/creditcard/TeaserDidYouKnow";
import TeaserLogInLogOutFinance from "../ads/creditcard/TeaserLogInLogOutFinance";
import BrandPage from "../ads/brandPage/BrandPage";

import mock from '../../mock/campaign';
import { SuperscriptProvider } from '../utils/SuperscriptHelper'


export default class Campaign extends React.Component {
    switchLabels = {off: 'Desktop view', on: 'Mobile view'}
    campaign = this.props.campaign
    lang = this.campaign.languageVersion
    campaignBlocks = this.campaign.blocks

    table = this.campaign.table
    partnerLogo = this.campaign.partnerLogo
    partnerLogoSvg = this.campaign.partnerLogoSvg
    flagFilter = this.campaign.flagcomponents || []
    ccMedienFilter = this.campaign.ccmedien || []
    logoFilter = this.campaign.logo || []
    photoCredit = this.campaign.photoCredit || {}

    appChallengeValues = this.campaign.appChallengeCenter || mock.appChallengeCenter;
    quiz = this.campaign.quiz;

    isWebOverlayTextLight = this.campaign.headlineColorWeb === 'White'
    isAppOverlayTextLight = this.campaign.headlineColorApp === 'White'
    isViewAllMode = (this.props.routeParams
                    && this.props.routeParams.filter
                    && this.props.routeParams.filter.toLowerCase() === 'all')
                    || false

    componentDidMount() {
        this.parseMilesCharacter()
    }

    parseMilesCharacter() {
        const mamSymbolContent = document.querySelectorAll('.js-mam-symbol-content')
        const milesCharacter = '<span class="mam-currency-symbol">M</span>'
        const milesRegex = /{m}|-m-/gi

        mamSymbolContent.forEach(content => content.innerHTML = content.innerHTML.replace(milesRegex, milesCharacter))
    }

    campaignHeader = (
        <div className="campaignHeader">

            {this.partnerLogo
            && <img className="campaignHeader-metadata-partner-logo"
                    src={this.partnerLogo} alt="Partner Logo" />}

            <h2 className="campaignHeader-metadata-name">
                {this.props.campaign.campaign_name}
            </h2>

            <section className="campaignHeader-metadata">
                <strong>Partner:</strong>{this.props.campaign.partner}<br />

                <strong>Language:</strong>{this.props.campaign.languageVersion}<br />

                <strong>Start/Due Date:</strong>{this.props.campaign.start_date} &ndash; {this.props.campaign.due_date}<br />

                <strong>Status:</strong>{this.props.campaign.state}<br />

                <strong>Version:</strong>{this.props.campaign.versionNr}<br />

                <strong>Comment:</strong>{this.props.campaign.comment}<br />
            </section>
        </div>
    )

    isComponentActive = ({filterName}) => this.props.campaign.activeComponents
            .includes(filterName);

    hasSwitch = sectionId => ['web', 'email', 'brandPage'].includes(sectionId)

    isMobile = sectionId => this.props.isMobile[sectionId] || false

    webComponents = [
        {
            name: 'Brandpage',
            filterName: 'Brandpage',
            component: <BrandPage lang={this.lang}
                                  campaign={this.campaignBlocks}
                                  partnerLogo={this.partnerLogo}
                                  bigIndices={true}
                                  footnotesWarningText={false}
                                  flagFilter={this.flagFilter}
                                  logoFilter={this.logoFilter}
                                  isMobile={this.isMobile} />
        },
        {
            name: 'Promotion Offer Page',
            filterName: 'Promotion Offer Page',
            component: <PromoOfferPage campaign={this.campaignBlocks}
                                       table={this.table}
                                       partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                       flagFilter={this.flagFilter}
                                       logoFilter={this.logoFilter}
                                       bigIndices={true}
                                       footnotesWarningText={false}
                                       isMobile={this.isMobile} />
        },
        {
            name: 'Basic Offer Page',
            filterName: 'Basic Offer Page',
            component: <BasicOfferPage campaign={this.campaignBlocks}
                                       table={this.table}
                                       partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                       bigIndices={true}
                                       footnotesWarningText={false}
                                       flagFilter={this.flagFilter}
                                       logoFilter={this.logoFilter}
                                       isMobile={this.isMobile} />
        },
        {
            name: 'Revolving Stage',
            filterName: 'Revolving Stage',
            component: <NewRevolvingStage campaign={this.campaignBlocks}
                                          partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                          bigIndices={true}
                                          isCcMedien={false}
                                          isWebComponent={true}
                                          footnotesWarningText={true}
                                          flagFilter={this.flagFilter}
                                          logoFilter={this.logoFilter}
                                          isMobile={this.isMobile} />
        },
        {
            name: 'Category Stage',
            filterName: 'Category Stage',
            component: <OfferBanner type="earn"
                                    campaign={this.campaignBlocks}
                                    image={this.campaignBlocks.image_5_2}
                                    bigIndices={true}
                                    footnotesWarningText={true}
                                    partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                    flagFilter={this.flagFilter}
                                    isWebComponent={true}
                                    logoFilter={this.logoFilter}
                                    isMobile={this.isMobile} />
        },
        {
            name: 'Banner Spend',
            filterName: 'Banner Spend',
            component: <OfferBannerSpend type="spend"
                                    campaign={this.campaignBlocks}
                                    image={this.campaignBlocks.image_3_4}
                                    bigIndices={true}
                                    footnotesWarningText={true}
                                    partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                    flagFilter={this.flagFilter}
                                    isWebComponent={true}
                                    logoFilter={this.logoFilter}
                                    isMobile={this.isMobile} />
        },
        {
            name: 'Carousel Earn',
            filterName: 'Carousel Earn',
            component: <OfferPromo carouselHeadline="Exciting ways to earn miles"
                                   lang={this.lang}
                                   campaign={this.campaignBlocks}
                                   image={this.campaignBlocks.image_16_9}
                                   bigIndices={true}
                                   footnotesWarningText={true}
                                   partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                   flagFilter={this.flagFilter}
                                   logoFilter={this.logoFilter}
                                   isWebComponent={true}
                                   isMobile={this.isMobile} />
        },
        {
            name: 'Carousel Spend',
            filterName: 'Carousel Spend',
            component: <OfferPromo carouselHeadline="Exciting ways to spend miles"
                                   lang={this.lang}
                                   campaign={this.campaignBlocks}
                                   bigIndices={true}
                                   footnotesWarningText={true}
                                   image={this.campaignBlocks.image_3_4}
                                   partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                   flagFilter={this.flagFilter}
                                   logoFilter={this.logoFilter}
                                   isWebComponent={true}
                                   isMobile={this.isMobile} />
        },
        {
            name: 'Teaser Award Booking Confirmation Screen',
            filterName: 'Teaser Award Booking Confirmation Screen',
            component: <TeaserAwardBookingConfirmationScreen campaign={this.campaignBlocks}
                                                             bigIndices={true}
                                                             footnotesWarningText={false}
                                                             logoFilter={this.logoFilter}
                                                             isMobile={this.isMobile} />
        },
        {
            name: 'Teaser Basic Offer',
            filterName: 'Teaser Basic Offer',
            component: <OfferTeaser campaign={this.campaignBlocks}
                                    lang={this.lang}
                                    bigIndices={true}
                                    footnotesWarningText={true}
                                    partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                    flagFilter={this.flagFilter}
                                    logoFilter={this.logoFilter}
                                    isWebComponent={true}
                                    isMobile={this.isMobile} />
        },
        {
            name: 'Offer Hub',
            filterName: 'Offer Hub',
            component: <OfferHub campaign={this.campaignBlocks}
                                 partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                 bigIndices={true}
                                 footnotesWarningText={true}
                                 flagFilter={this.flagFilter}
                                 logoFilter={this.logoFilter}
                                 isWebComponent={true}
                                 isMobile={this.isMobile} />
        }
    ]

    appComponents = [
        {
            name: 'Select/Basic Slot [App Stream]',
            filterName: 'Teaser App Stream Basic/Premium',
            component: <TeaserAppStreamBasic campaign={this.campaignBlocks}
                                             flagFilter={this.flagFilter}
                                             footnotesWarningText={false}
                                             partnerLogo={this.partnerLogo}
                                             logoFilter={this.logoFilter}
                                             partnerLogoSvg={this.partnerLogoSvg} />
        },
        {
            name: 'Detail View',
            filterName: 'Detail View App',
            component: <DetailViewApp campaign={this.campaignBlocks}
                                      flagFilter={this.flagFilter}
                                      footnotesWarningText={false}
                                      partnerLogo={this.partnerLogo}
                                      logoFilter={this.logoFilter}
                                      partnerLogoSvg={this.partnerLogoSvg}/>
        },
        {
            name: 'Photo Credit App',
            filterName: 'Photo Credit',
            component: <PhotoCredit campaign={this.campaignBlocks}
                                    photoCredit={this.photoCredit}
                                    partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                    partner={this.props.campaign.partner}
                                    lang={this.lang}/>

        },
        {
            name: 'App Challenge Center',
            filterName: 'App Challenge Center',
            component: <AppChallengeCenter challengeValues={this.appChallengeValues} 
                                            campaign={this.campaignBlocks}
                                            partnerLogo={this.partnerLogo}
                                            flagFilter={this.flagFilter} />
        },
        {
            name: 'App Quiz',
            filterName: 'App Quiz',
            component: <AppQuiz campaign={this.campaignBlocks} 
                                    quiz={this.quiz} 
                                    partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                    partner={this.props.campaign.partner}
                                    lang={this.lang}/>

        } 
    ]

    mailComponents = [
        {
            name: 'Premium Offer',
            filterName: 'Premium Offer',
            component: <PremiumOffer campaign={this.campaignBlocks}
                                     partnerLogo={this.partnerLogo}
                                     flagFilter={this.flagFilter}
                                     logoFilter={this.logoFilter}
                                     isMobile={this.isMobile}
                                     footnotesWarningText={false} />
        },
        {
            name: 'Top Offer',
            filterName: 'Top Offer',
            component: <TopOffer campaign={this.campaignBlocks}
                                 partnerLogo={this.partnerLogo}
                                 flagFilter={this.flagFilter}
                                 logoFilter={this.logoFilter}
                                 isMobile={this.isMobile}
                                 footnotesWarningText={false} />
        },
        {
            name: 'Basic Offer',
            filterName: 'Basic Offer',
            component: <BasicOffer campaign={this.campaignBlocks}
                                   partnerLogo={this.partnerLogo}
                                   flagFilter={this.flagFilter}
                                   logoFilter={this.logoFilter}
                                   isMobile={this.isMobile}
                                   footnotesWarningText={false} />
        }
    ]

    creditCardComponents = [
        {
            name: 'Revolving Stage',
            filterName: 'Revolving Stage CC',
            component: <NewRevolvingStage campaign={this.campaignBlocks}
                                          partnerLogo={this.partnerLogoSvg || this.partnerLogo}
                                          flagFilter={this.flagFilter}
                                          isMobile={this.isMobile}
                                          isCcMedien={true}
                                          isWebComponent={false}
                                          ccMedienFilter={this.ccMedienFilter}
                                          footnotesWarningText={false} />
        },
        {
            name: 'Teaser Aktionen',
            filterName: 'Teaser Aktionen',
            component: <TeaserAction campaign={this.campaignBlocks}
                                     partnerLogo={this.partnerLogo}
                                     flagFilter={this.flagFilter}
                                     isMobile={this.isMobile}
                                     ccMedienFilter={this.ccMedienFilter}
                                     footnotesWarningText={false} />
        },
        {
            name: 'Teaser „Weitere Angebote“',
            filterName: 'Teaser Weitere Angebote',
            component: <TeaserAdditionalOffer campaign={this.campaignBlocks}
                                              flagFilter={this.flagFilter}
                                              isMobile={this.isMobile}
                                              ccMedienFilter={this.ccMedienFilter}
                                              footnotesWarningText={false} />
        },
        {
            name: 'Teaser Login, Logout, Finanzüberblick',
            filterName: 'Teaser Login Logout Finanzüberblick',
            component: <TeaserLogInLogOutFinance campaign={this.campaignBlocks}
                                                 flagFilter={this.flagFilter}
                                                 isMobile={this.isMobile}
                                                 ccMedienFilter={this.ccMedienFilter}
                                                 footnotesWarningText={false} />
        },
        {
            name: 'Teaser „Wussten Sie schon“',
            filterName: 'Teaser Wussten Sie Schon',
            component: <TeaserDidYouKnow campaign={this.campaignBlocks}
                                         flagFilter={this.flagFilter}
                                         isMobile={this.isMobile}
                                         ccMedienFilter={this.ccMedienFilter}
                                         footnotesWarningText={false} />
        }
    ]

    renderCampaignContentTabs() {
        return (
            <Tabs id="campaign-content-tabs" className="campaign-content-tabs">
                {[
                    {title: 'Web', sectionId: 'web', content: this.webComponents},
                    {title: 'App', sectionId: 'app',  content: this.appComponents},
                    {title: 'Email Newsletter', sectionId: 'email', content: this.mailComponents},
                    {title: 'Web Credit Card', sectionId: 'creditCard', content: this.creditCardComponents},
                ].map(this.renderTab, this)}
            </Tabs>
        )
    }

    renderTab({title, sectionId, content}, i) {

        if (!this.isViewAllMode) {
            content = content.filter(this.isComponentActive, this)
        }

        if (content.length === 0) return

        return (
            <Tab key={i}
                eventKey={sectionId}
                title={title}
                className="campaign-content-tabs__tab">
                <section id={sectionId}
                        className="cp-previewPanel">

                    {this.hasSwitch(sectionId)
                        && <Switch label={this.switchLabels}
                                checked={this.props.isMobile[sectionId]}
                                onChange={() => this.props.onViewToggle(sectionId)} />}

                    {content.map((item, i) => (
                        <SuperscriptProvider footnotes={this.campaignBlocks.footnotes} key={i}>
                            <h2 className="component-headline">{item.name}:</h2>
                            {item.component}
                            <hr />
                        </SuperscriptProvider>
                    ))}

                </section>
            </Tab>
        )
    }

    renderPdfDownload() {
        return (
            <div className="campaign-pdf">
                <button className='campaign-pdf-btn' onClick={() => window.print()}>
                    <span className='campaign-pdf-text'>Download PDF</span>
                </button>
            </div>
        )
    }

    renderPrint2PdfHint() {
        return (
            <div className="campaign-pdf-hint">
                <span className='campaign-pdf-hint__text'>ACHTUNG: Option "Hintergrund drucken" ist nicht aktiviert!</span>
            </div>
        )
    }

    render() {
        return (
            <div className="campaign">
                {this.campaignHeader}
                {this.renderPrint2PdfHint()}
                {this.renderPdfDownload()}
                {this.renderCampaignContentTabs()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Campaign.js